import React, { Component } from 'react'
import DragAndDropBox from './DragAndDropBox'
import { saveData } from '../../helpers/axios/Post'
import { HOST_URL } from '../../helpers/constants/Constants'

const axios = require('axios');

class InputUploadFile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      files: [],
    }
  }

  getResponse = (response) => {
    let name = this.props.id
    if (response.status === 200) {
      this.props.compStatusCheck({ [name]: true })
    } else {
      this.props.compStatusCheck({ [name]: false })
    }
    this.props.getResponse(response)
  }

  componentDidMount() {
    let name = this.props.id
    this.props.compStatusCheck({ [name]: false })
  }

  uploadFiles = (files) => {
    // Push all the axios request promises into a single array
    const filesToUpload = Array.from(files).map(file => {
      const formData = new FormData();
     
      formData.append("SourceDataset_XLSXR", file, file.name);
      formData.append("ProjectId", this.props.projectid);
      formData.append("Key", this.props.id);

      const config = {
        method: 'post',
        url: HOST_URL + '/api/uploadfile',
        headers: { "Content-Type": "application/json" },
        data: formData,
        withCredentials: true
      }
      
      return saveData(config, this.getResponse, this.props.initializedCall)
    });

    axios.all(filesToUpload)
    
    // TO DO: CHeck response and indiciate to user files
    // are uploading and notify users on success
  }

  handleDrop = (files) => {
    let fileList = [];
    files.forEach((file) => {
      fileList.push(file.name)
    })

    this.setState({ files: fileList })
    this.uploadFiles(files);
  }

  render() {
    return (
      <DragAndDropBox handleDrop={this.handleDrop} files={this.state.files}/>
    )
  }
}

export default InputUploadFile